export enum OrdersAutoCancelPaymentMethod {
  PIX = "pix",
  BOLETO = "boleto",
  CREDIT_CARD = "credit_card",
  WIRE_TRANSFER = "wire_transfer",
  WALLET = "wallet",
}

export default OrdersAutoCancelPaymentMethod;
